export const environment = {
  production: true,
  version: '30394a6d5c',
  site_version: 'SITE_VERSION'
};
